export default "__VITE_ASSET__DLHKPJoo__"